import { Camera, Shield } from "lucide-react";

const WordGateSection = () => {
  return (
    <div className="mb-16">
      <h2 className="text-2xl font-bold mb-8">WordGate™ Camera Tracking Technology</h2>
      <div className="bg-gradient-to-r from-[#069E50]/10 to-[#069E50]/5 rounded-lg p-8 border border-[#069E50]/20">
        <div className="flex items-start gap-4">
          <Camera className="h-10 w-10 text-[#069E50] mt-1 flex-shrink-0" />
          <div>
            <h3 className="text-xl font-semibold mb-3 text-[#069E50]">
              Patented AI-Powered Camera Tracking — Like No Other
            </h3>
            <p className="text-muted-foreground text-lg leading-relaxed mb-4">
              WordGate™ technology was invented and patented by Aurora engineers. Unlike conventional voice-activated camera systems that rely solely on sound levels, WordGate™ uses <strong>artificial intelligence to detect speech intelligibility</strong> in over <strong>100 languages</strong>, combined with <strong>Sound Pressure Level (SPL) analysis</strong>, to trigger camera presets with pinpoint accuracy.
            </p>
            <p className="text-muted-foreground text-lg leading-relaxed mb-6">
              This dual-analysis approach <strong>eliminates false triggering</strong> caused by clapping, coughing, paper rustling, and other unintended noises — a common frustration with traditional camera tracking systems. The result is a meeting experience where the camera always focuses on the right person at the right time.
            </p>
            <div className="grid gap-4 md:grid-cols-2">
              <div className="bg-background/50 rounded-lg p-4">
                <h4 className="font-semibold mb-2 flex items-center gap-2">
                  <Shield className="h-4 w-4 text-[#069E50]" />
                  What WordGate™ Responds To
                </h4>
                <ul className="text-sm text-muted-foreground space-y-1">
                  <li>✓ Actual speech in 100+ languages</li>
                  <li>✓ Natural conversation and discussion</li>
                  <li>✓ Presentations and lectures</li>
                </ul>
              </div>
              <div className="bg-background/50 rounded-lg p-4">
                <h4 className="font-semibold mb-2 flex items-center gap-2">
                  <Shield className="h-4 w-4 text-destructive" />
                  What WordGate™ Ignores
                </h4>
                <ul className="text-sm text-muted-foreground space-y-1">
                  <li>✗ Clapping and applause</li>
                  <li>✗ Coughing and sneezing</li>
                  <li>✗ Paper rustling and tapping</li>
                  <li>✗ Other non-speech noises</li>
                </ul>
              </div>
            </div>
            <p className="text-sm text-muted-foreground mt-4 italic">
              WordGate™ is available on all RXT desktop control panel models with SmartSpeak™ beamforming microphones.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WordGateSection;
